<app-angular-editor
  [id]="question.key"
  [formControlName]="question.key"
  [config]="{
  editable: true,
  sanitize: false,
  fonts: [{class: 'ubuntu', name:'Ubuntu'}],
  minHeight: question?.payload && question.payload.minHeight ? question.payload.minHeight : '150px' }"
></app-angular-editor>
